var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 28"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4267",
    transform: "translate(-.012 -.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#4267b2",
    "data-name": "Rectangle 2352",
    rx: 3,
    transform: "translate(.012 .5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.002 6.5H16.01a3.5 3.5 0 0 0-3.683 3.789v1.747h-2a.314.314 0 0 0-.313.314v2.532a.314.314 0 0 0 .313.314h2v6.387a.313.313 0 0 0 .313.314h2.612a.314.314 0 0 0 .313-.314V15.2h2.341a.313.313 0 0 0 .313-.314V12.35a.314.314 0 0 0-.313-.314h-2.34v-1.481c0-.712.169-1.073 1.094-1.073h1.341a.314.314 0 0 0 .313-.314V6.817a.314.314 0 0 0-.312-.317",
    "data-name": "Path 733"
  }))));
};
export default SvgFacebook;